import {registerPlugin} from "@capacitor/core";
import {LOCAL_STORAGE_KEYS} from "constants/AppConstants.js";

const UserContextPlugin: any = registerPlugin("UserContextPlugin");

export const NATIVE_UNIT_PREFERENCES_CHANGED_EVENT = "ws-unit-preferences-changed";

export function applyNativeUnitPreferences({speedUnit, distanceUnit, windUnit}: any): void {
  if (speedUnit) {
    localStorage.setItem(LOCAL_STORAGE_KEYS.settingSpeedUnit, speedUnit);
  }
  if (distanceUnit) {
    localStorage.setItem(LOCAL_STORAGE_KEYS.settingDistanceUnit, distanceUnit);
  }
  if (windUnit) {
    localStorage.setItem(LOCAL_STORAGE_KEYS.settingWindUnit, windUnit);
  }

  window.dispatchEvent(
    new CustomEvent(NATIVE_UNIT_PREFERENCES_CHANGED_EVENT, {
      detail: {speedUnit, distanceUnit, windUnit}
    })
  );
}

export function setupNativeUnitPreferencesListener(): any {
  return UserContextPlugin.addListener("unitPreferencesChanged", (prefs: any) => {
    applyNativeUnitPreferences(prefs);
  });
}
